(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bcb-keyboard-fit-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bcb-keyboard-fit')) {
  customElements.define('bcb-keyboard-fit', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.data = JSON.parse(this.querySelector('[data-fit-data]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-fit-strings]').textContent);
      this.model = this.querySelector('[data-model]');
      this.mode = this.querySelector('[data-mode]');
      this.padding = this.querySelector('[data-padding]');
      this.results = this.querySelector('[data-results]');
      this.announcement = this.querySelector('[data-announcement]');
      this.querySelector('[data-fit-controls]').hidden = false;
      this.addEventListener('input', () => this.update(), {signal:this.abort.signal});
      this.addEventListener('change', () => this.update(), {signal:this.abort.signal});
      const selected = new URLSearchParams(window.location.search).get('model');
      if (selected && selected.length < 100) this.model.value = selected;
      this.update();
    }
    normalise(value) { return value.toLowerCase().replace(/[^a-z0-9+]/g,''); }
    make(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    format(values) {return values.map(n=>Number(n.toFixed(1))).join(' × ')+' '+this.strings.mm;}
    link(text,url) {const a=this.make('a',text);a.href=url;return a;}
    productUrl(box) {return this.data.root+'products/'+box.handle;}
    update() {
      const packed=this.mode.value==='packed';
      this.querySelector('[data-model-fields]').hidden=packed;
      this.querySelector('[data-packed-fields]').hidden=!packed;
      this.results.replaceChildren();
      let model=null, body, required, padding=Number(this.padding.value);
      if (packed) {
        const inputs=[...this.querySelectorAll('[data-dimension]')];
        body=inputs.map(e=>Number(e.value));
        if(inputs.some((e,i)=>!e.value.trim() || !e.validity.valid || !Number.isFinite(body[i]) || body[i]<=0 || body[i]>3000)) {
          this.announcement.textContent=this.strings.invalid_packed; return;
        }
        required=body;
      } else {
        const q=this.normalise(this.model.value);
        model=this.data.models.find(m=>this.normalise(m.model)===q || this.normalise(m.model.split(' ').slice(1).join(' '))===q);
        if(!model) {this.announcement.textContent=this.model.value.trim()?this.strings.unknown_model:this.strings.empty_model;return;}
        body=model.dimensions;
        required=body.map(n=>n+padding*2);
      }
      this.announcement.textContent=this.strings.model_changed;
      this.results.append(this.make('h3',packed?this.strings.results_heading:model.model));
      const measurements=this.make('details',undefined,'bcb-fit-browse');
      measurements.append(this.make('summary',this.strings.measurements_title));
      if(!packed) {
        const p=this.make('p',this.strings.body_size+': '+this.format(body),'bcb-fit-size');
        p.append(' · ',this.link(this.strings.source,model.source));
        measurements.append(p);
        if(padding===25)this.results.append(this.make('p',this.strings.low_padding,'bcb-fit-warning'));
        if(model.customer_reported)this.results.append(this.make('p',this.strings.p225,'bcb-fit-warning'));
      }
      measurements.append(this.make('p',(packed?this.strings.packed_size:this.strings.required_size)+': '+this.format(required),'bcb-fit-size'));
      this.results.append(measurements);
      const boxes=this.dataset.box?this.data.boxes.filter(b=>b.key===this.dataset.box):this.data.boxes;
      let any=false;
      const grid=this.make('div',undefined,'bcb-fit-grid');
      for(const box of boxes) {
        const clearance=box.dimensions.map((n,i)=>(n-body[i])/2);
        const spare=box.dimensions.map((n,i)=>(n-required[i])/2);
        const min=Math.min(...spare);
        let status=min>=5?'room':min>=0?'close':Math.min(...clearance)<0?'no_body':'tight';
        any ||= min>=0;
        const card=this.make('article',undefined,'bcb-fit-card');
        card.dataset.status=status;
        card.append(this.make('h4',this.strings['box_'+box.key]));
        const cardMeasurements=this.make('details',undefined,'bcb-fit-browse');
        cardMeasurements.append(this.make('summary',this.strings.measurements_title));
        cardMeasurements.append(this.make('p',this.strings.box_limits+': '+this.format(box.dimensions)));
        const statusKey=packed?(min>=5?'packed_room':min>=0?'packed_close':'packed_no'):status;
        card.append(this.make('p',this.strings[statusKey],'bcb-fit-badge'));
        cardMeasurements.append(this.make('p',packed?this.strings.packed_space:this.strings.bare_space));
        const dl=this.make('dl',undefined,'bcb-fit-clearances');
        ['ends','front_back','above_below'].forEach((axis,i)=>{
          const cell=this.make('div');
          cell.append(this.make('dt',this.strings[axis]),this.make('dd',Number(clearance[i].toFixed(1))+' '+this.strings.mm));dl.append(cell);
        });
        cardMeasurements.append(dl);
        if(min<0)cardMeasurements.append(this.make('p',(packed?this.strings.extra_packed:this.strings.extra_needed)+': '+this.format(box.dimensions.map((n,i)=>Math.max(0,required[i]-n)))));
        card.append(this.make('p',packed?this.strings.packed_note:this.strings[status+'_note']));
        card.append(cardMeasurements);
        if(min>=0)card.append(this.link(this.strings.view_box,this.productUrl(box)));
        else if(this.dataset.box)card.append(this.link(this.strings.all_boxes,this.data.root+'collections/keyboard-digital-piano-shipping-boxes?model='+encodeURIComponent(model?.model||'')+'#KeyboardModelFinder'));
        grid.append(card);
      }
      this.results.append(grid);
      if(!any) {
        this.results.append(this.make('p',this.dataset.box?(packed?this.strings.no_current_packed:this.strings.no_current_box):(packed?this.strings.no_packed_box:this.strings.no_box),'bcb-fit-no-box'));
        this.results.append(this.link(this.strings.enquire,this.data.root+'pages/custom-box-enquiry'));
      }
    }
    disconnectedCallback() {this.abort?.abort();this.abort=null;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
